import { render, staticRenderFns } from "./Small.vue?vue&type=template&id=7600dcb6"
import script from "./Small.vue?vue&type=script&lang=js"
export * from "./Small.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports